import { BrowserRouter } from "react-router-dom";
import { AuthGate } from "./screens/signin/AuthGate";

/**
 * The router, and nothing else.
 *
 * main.tsx imports this as a DEFAULT export. If that ever changes, main.tsx must change in the
 * same commit or the app renders nothing.
 *
 * Where everything lives now:
 *   src/lib/       env (leaf) · types · storage · api · format · run · qa · website · diff
 *   src/hooks/     useReviewMachine · useWebsiteResearch · usePageMeta
 *   src/components/ AppShell (nav + topbar + routes + toast) · primitives · EmptyRunState
 *   src/screens/   signin · walkthrough · new · editplan · editor · review · library ·
 *                  settings · help · pipeline   (one directory each)
 *   src/styles/    tokens · base · primitives · chrome · screens/<name>.css (one layer each)
 */
function App() {
  return (
    <BrowserRouter>
      <AuthGate />
    </BrowserRouter>
  );
}

export default App;
